import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {DepositCategory} from '../../models/deposit-category-type.model';

@Injectable({
  providedIn: 'root'
})
export class DepositCategoryService {
  constructor(private readonly http: HttpClient) {
  }

  fetchDepositCategory(): Observable<DepositCategory[]> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get<DepositCategory[]>('api/deposit-category', { headers });
  }
}
